// Supply Pouch (regra do Arthur): poções e runas não ficam nas mochilas; vão todas para a Supply Pouch.
// Elas só saem de lá gastas ou destruídas, e o peso conta na capacidade do personagem.
import { POTIONS } from './combat.js';

const POTION_NAMES = new Set([...Object.keys(POTIONS), 'berserk potion', 'bullseye potion', 'mastermind potion', 'transcendence potion',
  'antidote potion', 'magic shield potion'].map((n) => n.toLowerCase()));
/** itens que terminam em "rune" mas não são runas de magia (quest, decoração, montaria) */
const NOT_RUNES = new Set(['ancient rune', 'part of a rune', 'spell rune', 'inert astral shaper rune', 'astral shaper rune', 'glowing rune',
  'ancient crypt rune', 'deathly crypt rune', 'fiery crypt rune', 'icy crypt rune', 'necromantic crypt rune', 'hireling sex change rune', 'sorc and druid attack rune']);

/** É suprimento (vai para a Supply Pouch)? */
export function isSupply(name: string): boolean {
  const n = name.toLowerCase();
  return POTION_NAMES.has(n) || (n.endsWith(' rune') && !NOT_RUNES.has(n));
}

/** id usado no cliente para a janela da Supply Pouch na lista de recipientes abertos */
export const POUCH_WINDOW = -1;
